import React, { useMemo } from 'react';
import { SearchTableColumnSortButtonProps } from '../../../types/search';

const SearchTableColumnSortButton = ({
  columnKey,
  columnLabel,
  onSortChange,
  sortOrders = ['1', '2'],
  sortCol,
  sortOrder,
}: SearchTableColumnSortButtonProps) => {
  const isActive = useMemo(() => sortCol === columnKey, [sortCol, columnKey]);

  const icon = useMemo(() => {
    if (!isActive) return '';

    if (sortOrder === sortOrders[0]) {
      return 'nav-arrow-down-solid';
    }

    return 'nav-arrow-up-solid';
  }, [isActive, sortOrder, sortOrders]);

  const handleOnClick = () => {
    let newSortOrder = sortOrders[0];
    if (isActive) {
      if (sortOrder === sortOrders[0]) {
        newSortOrder = sortOrders[1];
      } else if (sortOrder === sortOrders[1]) {
        newSortOrder = sortOrders[0];
      }
    }

    onSortChange(newSortOrder, columnKey);
  };

  return (
    <>
      <label htmlFor={`col-${columnKey}-sort`} className="sr-only">
        Sort by {columnLabel}
      </label>
      <button
        id={`col-${columnKey}-sort`}
        className={`dynamic-table__sort-button${isActive ? ' dynamic-table__sort-button--active' : ''}`}
        onClick={handleOnClick}
      >
        <span className="dynamic-table__sort-button-label">{columnLabel}</span>
        {isActive && (
          <svg className="dynamic-table__sort-button-icon icon" aria-hidden="true">
            <use href={`/dist/assets/icons/sprite.svg#${icon}`}></use>
          </svg>
        )}
      </button>
    </>
  );
};

export default SearchTableColumnSortButton;
